import React from "react";
import { useI18n } from "./index";

/**
 * Sélecteur FR/EN discret pour les pages publiques (parcours donateur).
 * Style neutre : s'intègre aux headers clairs comme sombres via `onDark`.
 */
export default function LanguageSwitcher({ onDark = false, className = "" }) {
  const { lang, setLang } = useI18n();
  const base = onDark ? "text-white/70" : "text-stone-400";
  const active = onDark ? "text-white font-semibold" : "text-stone-900 font-semibold";
  return (
    <div className={`inline-flex items-center gap-1 text-xs select-none ${className}`} data-testid="lang-switcher">
      <button
        type="button"
        onClick={() => setLang("fr")}
        className={`px-1.5 py-1 transition-colors ${lang === "fr" ? active : base}`}
        aria-pressed={lang === "fr"}
      >
        FR
      </button>
      <span className={base}>·</span>
      <button
        type="button"
        onClick={() => setLang("en")}
        className={`px-1.5 py-1 transition-colors ${lang === "en" ? active : base}`}
        aria-pressed={lang === "en"}
      >
        EN
      </button>
    </div>
  );
}
